/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentExport } from '../models/document-export';
import { DocumentModels } from '../models/document-models';
import { ExportDocuments } from '../models/export-documents';
import { exportDocumentsBuildImageInputFile } from '../fn/export-documents/export-documents-build-image-input-file';
import { ExportDocumentsBuildImageInputFile$Params } from '../fn/export-documents/export-documents-build-image-input-file';
import { exportDocumentsDetail } from '../fn/export-documents/export-documents-detail';
import { ExportDocumentsDetail$Params } from '../fn/export-documents/export-documents-detail';
import { exportDocumentsDownloadFile } from '../fn/export-documents/export-documents-download-file';
import { ExportDocumentsDownloadFile$Params } from '../fn/export-documents/export-documents-download-file';
import { exportDocumentsExportDocumentsDetail } from '../fn/export-documents/export-documents-export-documents-detail';
import { ExportDocumentsExportDocumentsDetail$Params } from '../fn/export-documents/export-documents-export-documents-detail';
import { exportDocumentsGetDocumentList } from '../fn/export-documents/export-documents-get-document-list';
import { ExportDocumentsGetDocumentList$Params } from '../fn/export-documents/export-documents-get-document-list';
import { exportDocumentsGetExportCcda } from '../fn/export-documents/export-documents-get-export-ccda';
import { ExportDocumentsGetExportCcda$Params } from '../fn/export-documents/export-documents-get-export-ccda';
import { exportDocumentsGetPdf } from '../fn/export-documents/export-documents-get-pdf';
import { ExportDocumentsGetPdf$Params } from '../fn/export-documents/export-documents-get-pdf';
import { exportDocumentsGetPendingDocuments } from '../fn/export-documents/export-documents-get-pending-documents';
import { ExportDocumentsGetPendingDocuments$Params } from '../fn/export-documents/export-documents-get-pending-documents';
import { ExportDocumentsModelDto } from '../models/export-documents-model-dto';

@Injectable({ providedIn: 'root' })
export class ExportDocumentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportDocumentsGetDocumentList()` */
  static readonly ExportDocumentsGetDocumentListPath = '/exportdocument/emrlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsGetDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetDocumentList$Response(params?: ExportDocumentsGetDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocuments>> {
    return exportDocumentsGetDocumentList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsGetDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetDocumentList(params?: ExportDocumentsGetDocumentList$Params, context?: HttpContext): Observable<ExportDocuments> {
    return this.exportDocumentsGetDocumentList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportDocuments>): ExportDocuments => r.body)
    );
  }

  /** Path part for operation `exportDocumentsGetPendingDocuments()` */
  static readonly ExportDocumentsGetPendingDocumentsPath = '/exportdocument/getPendingDocuments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsGetPendingDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetPendingDocuments$Response(params?: ExportDocumentsGetPendingDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentExport>>> {
    return exportDocumentsGetPendingDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsGetPendingDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetPendingDocuments(params?: ExportDocumentsGetPendingDocuments$Params, context?: HttpContext): Observable<Array<DocumentExport>> {
    return this.exportDocumentsGetPendingDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentExport>>): Array<DocumentExport> => r.body)
    );
  }

  /** Path part for operation `exportDocumentsGetPdf()` */
  static readonly ExportDocumentsGetPdfPath = '/exportdocument/getdocument';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsGetPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetPdf$Response(params?: ExportDocumentsGetPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportDocumentsGetPdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsGetPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetPdf(params?: ExportDocumentsGetPdf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportDocumentsGetPdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportDocumentsGetExportCcda()` */
  static readonly ExportDocumentsGetExportCcdaPath = '/exportdocument/getExportCCDA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsGetExportCcda()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetExportCcda$Response(params?: ExportDocumentsGetExportCcda$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocumentsModelDto>> {
    return exportDocumentsGetExportCcda(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsGetExportCcda$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsGetExportCcda(params?: ExportDocumentsGetExportCcda$Params, context?: HttpContext): Observable<ExportDocumentsModelDto> {
    return this.exportDocumentsGetExportCcda$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportDocumentsModelDto>): ExportDocumentsModelDto => r.body)
    );
  }

  /** Path part for operation `exportDocumentsBuildImageInputFile()` */
  static readonly ExportDocumentsBuildImageInputFilePath = '/api/ExportDocuments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsBuildImageInputFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsBuildImageInputFile$Response(params?: ExportDocumentsBuildImageInputFile$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportDocumentsBuildImageInputFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsBuildImageInputFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsBuildImageInputFile(params?: ExportDocumentsBuildImageInputFile$Params, context?: HttpContext): Observable<string> {
    return this.exportDocumentsBuildImageInputFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `exportDocumentsExportDocumentsDetail()` */
  static readonly ExportDocumentsExportDocumentsDetailPath = '/exportdocument/getExportDocuments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsExportDocumentsDetail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDocumentsExportDocumentsDetail$Response(params: ExportDocumentsExportDocumentsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocumentsModelDto>> {
    return exportDocumentsExportDocumentsDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsExportDocumentsDetail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportDocumentsExportDocumentsDetail(params: ExportDocumentsExportDocumentsDetail$Params, context?: HttpContext): Observable<ExportDocumentsModelDto> {
    return this.exportDocumentsExportDocumentsDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportDocumentsModelDto>): ExportDocumentsModelDto => r.body)
    );
  }

  /** Path part for operation `exportDocumentsDetail()` */
  static readonly ExportDocumentsDetailPath = '/exportdocument/getdetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsDetail$Response(params?: ExportDocumentsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentModels>> {
    return exportDocumentsDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsDetail(params?: ExportDocumentsDetail$Params, context?: HttpContext): Observable<DocumentModels> {
    return this.exportDocumentsDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentModels>): DocumentModels => r.body)
    );
  }

  /** Path part for operation `exportDocumentsDownloadFile()` */
  static readonly ExportDocumentsDownloadFilePath = '/exportdocument/downloadCCDA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDocumentsDownloadFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsDownloadFile$Response(params?: ExportDocumentsDownloadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportDocumentsDownloadFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDocumentsDownloadFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDocumentsDownloadFile(params?: ExportDocumentsDownloadFile$Params, context?: HttpContext): Observable<Blob> {
    return this.exportDocumentsDownloadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
